import React from "react";
import styled from "styled-components";

export const Person = styled.span`
	color: #747474;
	font-size: 16px;
	font-weight: 300;
	letter-spacing: 0;
	line-height: 19px;
	text-align: center;
	text-transform: uppercase;
	display: block;
	margin-bottom: 35px;
	font-family: Mallory;
	@media (max-width: 767px){
		margin-bottom: 40px;
	}
`;

export const Content = styled.h3`
	color: #212323;
	font-size: 32px;
	font-weight: 300;
	letter-spacing: 1px;
	line-height: 44px;
	font-family: Mallory-Book;
	text-align: center;
	max-width: 604px;
	display: block;
	margin: auto;
	margin-bottom: 14px;
	margin-top: 35px;
	@media (max-width: 767px){
		margin: 31px 18px 21px;
	}
`;

export const Container = styled.div`
	margin: ${props => props.theme.spacing};
	max-width: ${props => props.theme.max};
	padding-bottom: 35px;
	padding-top: 35px;
	@media(max-width: 767px){
		margin:  ${(props) => props.theme.mobileSpacing};
	}
`;

export const Line = styled.div`
	background-color: #EFEDEB;
	max-width: 392px;
	height: 0.25px;
	display: block;
	margin: auto;
`;